import React from 'react';
import { Pressable } from 'react-native';
import { Text } from '@tamagui/core';
import { YStack, XStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';
import {
  getCardBackgroundColor,
  getCardBorderColor,
  getSeparatorColor,
  getButtonBackgroundColor,
  CARD_BORDER_RADIUS,
  CARD_PADDING,
  BUTTON_BORDER_RADIUS,
  FONT_SIZE_MD,
  FONT_SIZE_BASE,
  FONT_SIZE_XL,
  BORDER_WIDTH_THIN,
} from '../constants';

export type PaymentSummaryProps = {
  isDark: boolean;
  textColor: string;
  subtextColor: string;
  finalAmount: number;
  canProceed: boolean;
  onPayment: () => void;
};

const PaymentSummary: React.FC<PaymentSummaryProps> = React.memo(({
  isDark,
  textColor,
  subtextColor,
  finalAmount,
  canProceed,
  onPayment,
}) => {
  return (
    <YStack
      backgroundColor={getCardBackgroundColor(isDark)}
      borderRadius={CARD_BORDER_RADIUS}
      padding={CARD_PADDING}
      borderWidth={BORDER_WIDTH_THIN}
      borderColor={getCardBorderColor(isDark)}
      space="$2"
    >
      <XStack justifyContent="space-between" alignItems="center" paddingVertical="$2">
        <Text fontSize={FONT_SIZE_MD} color={subtextColor}>
          Kwota:
        </Text>
        <Text fontSize={FONT_SIZE_BASE} fontWeight="600" color={textColor}>
          {finalAmount.toFixed(2)} zł
        </Text>
      </XStack>

      <XStack justifyContent="space-between" alignItems="center" paddingVertical="$2">
        <Text fontSize={FONT_SIZE_MD} color={subtextColor}>
          Opłata:
        </Text>
        <Text fontSize={FONT_SIZE_BASE} fontWeight="600" color={textColor}>
          0 zł
        </Text>
      </XStack>

      <YStack
        height={1}
        backgroundColor={getSeparatorColor(isDark)}
        marginVertical="$2"
      />

      <XStack justifyContent="space-between" alignItems="center" paddingVertical="$2">
        <Text fontSize={FONT_SIZE_BASE} fontWeight="700" color={textColor}>
          Do zapłaty:
        </Text>
        <Text fontSize={FONT_SIZE_XL} fontWeight="700" color={textColor}>
          {finalAmount.toFixed(2)} zł
        </Text>
      </XStack>

      {/* Zapłać button */}
      <Pressable
        onPress={onPayment}
        disabled={!canProceed}
      >
        <YStack
          backgroundColor={getButtonBackgroundColor(canProceed)}
          padding="$4"
          borderRadius={BUTTON_BORDER_RADIUS}
          alignItems="center"
          marginTop="$3"
        >
          <Text fontSize={FONT_SIZE_BASE} fontWeight="700" color={COLORS.WHITE}>
            Zapłać {finalAmount.toFixed(2)} zł
          </Text>
        </YStack>
      </Pressable>
    </YStack>
  );
});

PaymentSummary.displayName = 'PaymentSummary';

export default PaymentSummary;

